module.exports = __webpack_public_path__ + "static/media/information.5b306ba7.svg";